import { instantsInterceptor, } from '@/api/index';

function getTpcdList(upperControllerId) {
    return instantsInterceptor.get('/service/tpcd/list?upperId='+upperControllerId);
}

function getMgmtTpcdList(upperControllerId) {
    return instantsInterceptor.get('/mgmt/tpcd/list?upperId='+upperControllerId);
}

function updateTpcdOrder(form) {
    return instantsInterceptor.post('/mgmt/tpcd/changeOrder', form);
}

function addTpcd(form) {
    return instantsInterceptor.post('/mgmt/tpcd/form', form);
}

function checkTpcdNameDuplication(form){
    return instantsInterceptor.post('/mgmt/tpcd/check', form);
}

function getTpcd(id) {
    return instantsInterceptor.get('/mgmt/tpcd/updateForm/'+id);
}

function update(form){
    return instantsInterceptor.post('/mgmt/tpcd/update', form);
}

function deleteTpcd(form){
    return instantsInterceptor.post('/mgmt/tpcd/delete', form);
}

function changeTpcdUse(form) {
    return instantsInterceptor.post('/mgmt/tpcd/changeUse', form);
}



export { getTpcdList,getMgmtTpcdList , updateTpcdOrder, addTpcd, checkTpcdNameDuplication, getTpcd, update, deleteTpcd, changeTpcdUse};